import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import assetsService from "../../services/rentals/assetsService";
import MediaUploader from "../../components/MediaUploader";

export default function AssetCreate() {
  const [form, setForm] = useState({
    vin: "",
    license_plate: "",
    make: "",
    model: "",
    year: new Date().getFullYear(),
    category: "car",
    specs: { seats: 4, transmission: "auto", fuel_type: "petrol" },
    base_location: "",
    pricing: { currency: "USD", daily: 0, per_km: 0 },
    images: [],
  });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setSaving(true);
    try {
      // Build payload matching backend model
      const payload = {
        vin: form.vin || undefined,
        license_plate: form.license_plate || undefined,
        make: form.make,
        model: form.model,
        year: Number(form.year),
        category: form.category,
        specs: {
          seats: Number(form.specs.seats) || 0,
          transmission: form.specs.transmission,
          fuel_type: form.specs.fuel_type,
        },
        base_location: form.base_location || null,
        pricing: {
          currency: form.pricing.currency || "USD",
          daily: Number(form.pricing.daily) || 0,
          per_km: Number(form.pricing.per_km) || 0,
        },
        images: form.images || [],
      };

      const res = await assetsService.createAsset(payload);
      const id = res._id || res.id;
      if (id) navigate(`/rentals/assets/${id}/edit`);
    } catch (e) {
      console.error("Failed creating asset", e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
        <FormControl>
          <FormLabel>VIN</FormLabel>
          <Input
            value={form.vin}
            onChange={(e) => setForm({ ...form, vin: e.target.value })}
            placeholder="1HGCM82633A004352"
          />
        </FormControl>

        <FormControl>
          <FormLabel>License Plate</FormLabel>
          <Input
            value={form.license_plate}
            onChange={(e) =>
              setForm({ ...form, license_plate: e.target.value })
            }
            placeholder="KA01AB1234"
          />
        </FormControl>

        <FormControl>
          <FormLabel>Base Location</FormLabel>
          <Input
            value={form.base_location}
            onChange={(e) =>
              setForm({ ...form, base_location: e.target.value })
            }
            placeholder="Store A"
          />
        </FormControl>

        <FormControl>
          <FormLabel>Make</FormLabel>
          <Input
            value={form.make}
            onChange={(e) => setForm({ ...form, make: e.target.value })}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Model</FormLabel>
          <Input
            value={form.model}
            onChange={(e) => setForm({ ...form, model: e.target.value })}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Year</FormLabel>
          <NumberInput
            value={form.year}
            onChange={(v) => setForm({ ...form, year: Number(v) })}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel>Category</FormLabel>
          <Select
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value })}
          >
            <option value="car">Car</option>
            <option value="bike">Bike</option>
            <option value="van">Van</option>
            <option value="other">Other</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Seats</FormLabel>
          <NumberInput
            value={form.specs.seats}
            onChange={(v) =>
              setForm({ ...form, specs: { ...form.specs, seats: Number(v) } })
            }
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel>Transmission</FormLabel>
          <Select
            value={form.specs.transmission}
            onChange={(e) =>
              setForm({
                ...form,
                specs: { ...form.specs, transmission: e.target.value },
              })
            }
          >
            <option value="auto">Auto</option>
            <option value="manual">Manual</option>
            <option value="cvt">CVT</option>
            <option value="other">Other</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Fuel Type</FormLabel>
          <Select
            value={form.specs.fuel_type}
            onChange={(e) =>
              setForm({
                ...form,
                specs: { ...form.specs, fuel_type: e.target.value },
              })
            }
          >
            <option value="petrol">Petrol</option>
            <option value="diesel">Diesel</option>
            <option value="electric">Electric</option>
            <option value="hybrid">Hybrid</option>
            <option value="other">Other</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Daily Price ({form.pricing.currency})</FormLabel>
          <NumberInput
            value={form.pricing.daily}
            onChange={(v) =>
              setForm({
                ...form,
                pricing: { ...form.pricing, daily: Number(v) },
              })
            }
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel>Per km Price</FormLabel>
          <NumberInput
            value={form.pricing.per_km}
            onChange={(v) =>
              setForm({
                ...form,
                pricing: { ...form.pricing, per_km: Number(v) },
              })
            }
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel>Images</FormLabel>
          <MediaUploader
            multiple
            value={form.images}
            onChange={(images) => setForm({ ...form, images })}
          />
        </FormControl>
      </SimpleGrid>

      <Box mt={4}>
        <Button colorScheme="teal" onClick={handleSubmit} isLoading={saving}>
          Create asset
        </Button>
      </Box>
    </Box>
  );
}
